/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationUpdateAccessMode } from '../../axios/organisationUpdateAccessMode'
import type {
	OrganisationUpdateAccessModeError,
	OrganisationUpdateAccessModePathParams,
	OrganisationUpdateAccessModeRequest,
	OrganisationUpdateAccessModeResponse,
} from '../../types/OrganisationUpdateAccessMode'

export const organisationUpdateAccessModeMutationKey = () =>
	[{ url: '/organisations/:organisation/access-mode' }] as const

export type OrganisationUpdateAccessModeMutationKey = ReturnType<typeof organisationUpdateAccessModeMutationKey>

export type OrganisationUpdateAccessModeVariables = {
	organisation: OrganisationUpdateAccessModePathParams['organisation']
	data: OrganisationUpdateAccessModeRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::updateAccessMode */
export function useOrganisationUpdateAccessMode<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationUpdateAccessModeResponse,
		AxiosError<OrganisationUpdateAccessModeError>,
		OrganisationUpdateAccessModeVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationUpdateAccessModeMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationUpdateAccessModeVariables) =>
			organisationUpdateAccessMode(organisation, data, config).then(res => res.data),
		...options,
	})
}
